import Axios from "axios";

export default {

    ApiLogin: (data) => {
        return Axios.post('/login/common/', data)
    },

    RefreshToken: (data) => {
        return Axios.post('/token/refresh/',data)
    }
}